import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Optional, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {ExcelExportProperties, GridColumnModel, GridComponent, SearchSettingsModel, FilterService, InfiniteScrollService, PageService} from '@syncfusion/ej2-angular-grids';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { CommonService } from '../../../shared/services/common.service';
import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import {getExcelDataSource, gridActionBeginForFilteringOdataV4, gridActionsForFiltering, updateFilterIcon, applyInfiniteGridTotalCount, bindInfiniteScrollPrefetch} from '../../../shared/models/utils/grid-functions';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { LeadsPopupComponent } from '../leads-popup/leads-popup.component';
import { LeadsService } from '../leads.service';
import { gridNames } from '../../../shared/models/grid.model';
import { Applications, tabsModel, ModuleNames } from '../../../shared/models/app.model';
import { GridPersistRequests, UserRoles } from '../../../shared/constants/app.constants';
import { defaultProspectData } from '../../business-partners/model/prospects-data';
import { ProspectsPopupComponent } from '../../business-partners/prospects-popup/prospects-popup.component';
import { OpportunitiesPopupComponent } from '../../opportunities/opportunities-popup/opportunities-popup.component';
import { SharedService } from 'projects/shared/src/public-api';
import { getCurrentDate } from '../../../shared/models/utils/date-functions';
import { HomeService } from '../../home/home.service';
import { APP_CONFIG, AppConfig } from 'projects/shared/src/lib/app-config.token';
import { ActivatedRoute } from '@angular/router';
import { ToDosPopupComponent } from '../../todos/to-dos-popup/to-dos-popup.component';
let SALES_API_URL = '';

@Component({
    selector: 'app-leads-grid',
    templateUrl: './leads-grid.component.html',
    styleUrl: './leads-grid.component.scss',
    providers: [FilterService, InfiniteScrollService, PageService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeadsGridComponent implements OnInit{
  public infiniteScrollSettings: any = { enableCache: false, initialBlocks: 1, maxBlocks: 10 };
  totalRecords: number = 0;

  dataSource: any;
  columns!: GridColumnModel[]
  grid!: GridComponent;
  searchSettings?: SearchSettingsModel;
  showLoader = true;
  gridHeight: number = window.innerHeight - 250;
  obsoleteItemsExists: boolean = false
  private subscription?: Subscription;
  rolePermissions: any = {}
  rolePermissionsLoaded = false
  persistenceLoaded = false;
  get gridName() {
    return this.isFromService ? 'serviceLeadsGrid' : gridNames.leadsGrid;
  }
  showGrid = false
  
  checkAndShowGrid() {
    if (this.persistenceLoaded && this.rolePermissionsLoaded) {
      this.showGrid = true;
      this.showLoader = false;
    }
  }

  @Input() isFromService: boolean = false;
  @Input() isFromServiceOrder: boolean = false;
  
  prospectData = defaultProspectData;

  query: Query;

  showProspectsPopup = false
  // isOpenedFromDashboard = false

  @ViewChild('columnChooser') columnChooser: any;
  @ViewChild('addLeads') addLeads: any;
  @ViewChild('obsoleteItemToolbar') obsoleteItemToolbar: any;

  @ViewChild('leadsGrid') set gridComponent(gridComponent: GridComponent) {
    if (gridComponent) {
      this.grid = gridComponent;
      if (this.rolePermissionsLoaded) {
        this.setToolbar();
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.gridHeight = window.innerHeight - 250;
  }

  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    public dialog: MatDialog,
    private commonService: CommonService,
    private leadsService: LeadsService,
    private route: ActivatedRoute,
    private homeService: HomeService,
    private authService: AuthService,
    private sharedService: SharedService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() public dialogRef: MatDialogRef<any>
  ) {
    this.showLoader = false
    SALES_API_URL = this.config.saleApiUrl;
  }

  ngOnInit(): void {
    this.getRolePermission()
    this.initData();
  }
  initData() {
    this.searchSettings = {
      fields: [
        'salesLeadId',
        'soldToBPName',
        'productCategory',
        'zipCode',
        'stateProvince',
        'telephone',
        'creatorName',
        'source',
        'salesRepName',
      ]
    };
    this.query = new Query();
    if(this.dialogData?.isOpenedFromDashboard) {
      const USER = this.commonService.getUSER();
      if(USER?.role == UserRoles.salesRep) {
        this.query.addParams('salesRepId', USER?.userId);
      }
      this.searchSettings.fields.push("region", "district", "territory");
      if(this.dialogData?.filteredStatus && this.dialogData?.filteredStatus != "All") {
        this.query?.where('statusText', 'equal', this.dialogData?.filteredStatus);
      }
      this.dialogData?.districts && (this.query.addParams('district', this.dialogData?.districts));
      this.dialogData?.regions && (this.query.addParams('region', this.dialogData?.regions));
    }

    this.dataSource = new DataManager({
      url: `${SALES_API_URL}odata/Lead`,
      adaptor: new ODataV4Adaptor(),
      headers: [{'Authorization': `Bearer ${this.authService.getToken()}`}]
    });

    this.loadPage();
  }
  loadPage() {
    this.commonService.getPersistence(this.gridName, this.commonService.getUserId(), Applications.RimsSales)
      .subscribe({
        next: (res: any) => {
          if (res && res.result && res.result.length && res.result[0].value) {
            localStorage.setItem(`grid${this.gridName}`, res.result[0].value);
          } else {
            localStorage.removeItem(`grid${this.gridName}`);
          }
          this.persistenceLoaded = true;
          this.checkAndShowGrid();
        },
        error: (err) => {
          this.persistenceLoaded = true;
          this.checkAndShowGrid();
          this.commonService.showNotification("error", err?.error?.message);
        }
      });
  }
  onCreated(e: any, grid: GridComponent) {
    this.route.queryParamMap.subscribe(params => {
      const primaryId = params.get('primaryId');
      const showComments = params.get('showComments') === 'true';

      if (primaryId && showComments) {
        this.openLeadsPopup(primaryId, tabsModel.details);
        setTimeout(() => {
          this.sharedService.globalComments = {
            grid: grid || this.grid,
            module: ModuleNames.SalesLead,
            moduleId: primaryId,
            showComments: true
          };
        }, 500);
        return;
      }
    });
    bindInfiniteScrollPrefetch(this.grid, () => this.totalRecords, 0, (count) => { this.totalRecords = count; });
}
  getColumns() {
    const commands = [];
     if(this.dialogData?.filteredStatus) {
      commands.push({ title: 'Details', buttonOption: { iconCss: 'fas fa-tasks', cssClass: 'e-flat details-item' } });
      if (!this.fromServiceApp) {
        commands.push({ title: 'Links', buttonOption: { iconCss: 'fas fa-link', cssClass: 'e-flat linked-items' } });
      }
      commands.push({ title: 'Comments', buttonOption: { iconCss: 'fas fa-comment', cssClass: 'e-flat comments-items' } });
      commands.push({ title: 'Attachments', buttonOption: { iconCss: 'fas fa-file-upload', cssClass: 'e-flat attachments-items' } });
      this.columns = [
        { field: "salesLeadId", headerText: "Lead ID", allowEditing: false, textAlign: 'Left', allowFiltering: true, allowSorting: true, width: 125, isPrimaryKey: true, showInColumnChooser: false },
        { field: 'soldToBPName', headerText: 'Customer', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 250, visible: true, showInColumnChooser: true },
        { field: 'assignedResourceName', headerText: 'Assigned Resource', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 250, visible: true, showInColumnChooser: true },
        { field: 'salesRepName', headerText: 'Primary Sales Rep', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'productCategory', headerText: 'Product', filter: { type: 'Excel' },  type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'zipCode', headerText: 'Zip Code', filter: { type: 'Excel' },  type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'territory', headerText: 'Territory', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: false },
        { field: 'district', headerText: 'District', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: false },
        { field: 'region', headerText: 'Region', filter: { type: 'Excel' },  type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: false },
        { field: 'stateProvince', headerText: 'State', filter: { type: 'Excel' },  type: 'String', allowEditing: false, width: 120, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: 'telephone', headerText: 'Telephone', type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: 'creatorName', headerText: 'Created By', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'source', headerText: 'Source', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'createdDate', headerText: 'Creation Date', type: 'date', textAlign: 'Left',  format: { type: 'date', format: 'd MMM, y' }, width: 180 },
        {
          field: 'Actions', headerText: 'Actions', width: 190, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false,
          commands: commands
        }
      ];

      if(this.dialogData?.filteredStatus == "All") {
        const soldToBPIndex = this.columns.findIndex(c => c.field === 'soldToBPName');
        this.columns.splice(soldToBPIndex + 1, 0, { field: 'statusText', headerText: 'Status', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 200, visible: true, showInColumnChooser: true });
      }
    }
    else {
      if ((this.rolePermissions['leadsGrid_mapBusinessPartner']?.visible ?? true) && !this.fromServiceApp) {
        commands.push({ title: 'Map Business Partner', buttonOption: { iconCss: 'fas fa-people-arrows', cssClass: 'e-flat map-business-partner-item' } });
      }
      if ((this.rolePermissions['leadsGrid_convertOpportunity']?.visible || this.commonService?.getUSER()?.canActAsSalesRep) && !this.fromServiceApp) {
        commands.push({ title: 'Convert to Opportunity', buttonOption: { iconCss: 'fas fa-arrow-right-arrow-left', cssClass: 'e-flat convert-opportunity-item' } });
      }
      if (this.rolePermissions['leadsGrid_details']?.visible ?? true) {
        commands.push({ title: 'Details', buttonOption: { iconCss: 'fas fa-tasks', cssClass: 'e-flat details-item' } });
      }
      if ((this.rolePermissions['leadsGrid_links']?.visible ?? true) && !this.fromServiceApp) {
        commands.push({ title: 'Links', buttonOption: { iconCss: 'fas fa-link', cssClass: 'e-flat linked-items' } });
      }
      if (this.rolePermissions['leadsGrid_comments']?.visible ?? true) {
        commands.push({ title: 'Comments', buttonOption: { iconCss: 'fas fa-comment', cssClass: 'e-flat comments-items' } });
      }
      commands.push({ title: 'Attachments', buttonOption: { iconCss: 'fas fa-file-upload', cssClass: 'e-flat attachments-items' } });
      if (this.rolePermissions['leadsGrid_history']?.visible ?? true) {
        commands.push({ title: 'History', buttonOption: { iconCss: 'fas fa-history', cssClass: 'e-flat history-item' } });
      }

      this.columns = [
        { field: "salesLeadId", headerText: "ID", allowEditing: false, textAlign: 'Left', allowFiltering: true, allowSorting: true, width: 125, isPrimaryKey: true, showInColumnChooser: false },
        { field: 'soldToBPName', headerText: 'Business Partner', type: 'string', allowEditing: false, textAlign: 'Left', width: 250, visible: true, showInColumnChooser: true },
        { field: 'assignedResourceName', headerText: 'Assigned Resource', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 250, visible: true, showInColumnChooser: true },
        { field: 'salesRepName', headerText: 'Primary Sales Rep', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 190, visible: true, showInColumnChooser: true },
        { field: 'statusText', headerText: 'Status', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 220, visible: true, showInColumnChooser: true },
        { field: 'soldToExtId', headerText: 'Business Partner ID', width: 190, visible: false, showInColumnChooser: true, type: 'string' },
        { field: 'productCategory', headerText: 'Product',  filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 280, visible: true, showInColumnChooser: true },
        { field: 'zipCode', headerText: 'Zip Code',  filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'stateProvince', headerText: 'State', filter: { type: 'Excel' },  type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: "country", headerText: "Country", filter: { type: 'Excel' }, type: 'string', allowEditing: false, width: 140, textAlign: 'Left', showInColumnChooser: true, visible: false },
        { field: 'telephone', headerText: 'Telephone', filter: { type: 'Excel' },  type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: 'creatorName', headerText: 'Created By', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'source', headerText: 'Source', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'createdDate', headerText: 'Created Date', type: 'date', textAlign: 'Left',  format: { type: 'date', format: 'd MMM, y' }, width: 180 },
        {
          field: 'Actions', headerText: 'Actions', width: 210, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false,
          commands: commands
        }
      ];

    }
  }


    onBPIdClick(soldToBP) {
      this.prospectData.soldToExtId = soldToBP;
      const dialogRef = this.dialog.open(ProspectsPopupComponent, {
        backdropClass: 'no-backdrop',
        disableClose: true,
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '100%',
        height: '100%',
        enterAnimationDuration: '0',
        exitAnimationDuration: '0',
        data: {
          showProspectsPopup: true,
          prospectData:this.prospectData,
          id: this.prospectData.soldToExtId,
          tab: tabsModel.details,
          isMaximized: true,
          // isReadOnly: true,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.grid.refresh();
      });
    }

  setToolbar() {
    this.grid.toolbar = [
      { id: 'column-chooser', template: this.columnChooser, tooltipText: 'Show/Hide Columns' },
      { id: 'refresh', align: 'Right', prefixIcon: 'fas fa-redo-alt', cssClass: '', tooltipText: 'Refresh' },
      'Search',
      { text: '', id: 'clear-filter', align: 'Right', prefixIcon: 'fas fa-filter', cssClass: `grid-filter-icon`, tooltipText: 'Clear all Filters' }
    ];
    
    if (this.commonService.getUSER()?.role !== UserRoles.salesRep) {
      const indexExcelExport = this.grid.toolbar.findIndex(fi => fi == 'Search');
      this.grid.toolbar.splice(indexExcelExport + 1, 0, { text: '', id: 'excel-export', align: 'Right', prefixIcon: 'e-excelexport', cssClass: `grid-add-button`, tooltipText: 'Excel Export' })
    }
    const index = this.grid.toolbar.findIndex((item: any) => item.id === 'column-chooser');
    if (index !== -1 && (this.rolePermissions['leadsGrid_add']?.visible) && !this.dialogData?.isOpenedFromDashboard) {
      this.grid.toolbar.splice(index + 1, 0, { id: 'add', align: 'Left', prefixIcon: 'fas fa-add', cssClass: '', tooltipText: 'Add' });
    }
  }

  getPersistence() {
    this.commonService.getPersistence(this.gridName, this.commonService.getUSER().userId, Applications.RimsSales).subscribe((res: any) => {
      if (res.result[0]?.value) {
        localStorage.setItem(`grid${this.gridName}`, res.result[0]?.value);
      } else {
        localStorage.removeItem(`grid${this.gridName}`);
      }
      this.showGrid = true
    }, (error: HttpErrorResponse) => {
      throw error;
    });
  }

  getRolePermission() {
    this.commonService.getRolePermission('leadsGrid','','lead').subscribe((res: any) => {
      res.result.forEach((rule: any) => {
        this.rolePermissions[rule.ruleAction] = {
            visible: rule.visible,
            readOnly: rule.readOnly,
            enable: rule.enable,
        }
    });
    this.rolePermissionsLoaded = true;
    this.getColumns();
    this.checkAndShowGrid();
    if (this.grid) {
      this.setToolbar();
    }
  }, (error: HttpErrorResponse) => {
      this.rolePermissionsLoaded = true;
      this.getColumns();
      this.checkAndShowGrid();
      if (this.grid) {
        this.setToolbar();
      }
      throw error;
    });
  }

  onToolbarClick(args: any ) {
    if (args.item.id === 'add') {
      this.openLeadsPopup()
    }  else if (args.item.id === 'refresh') {
      this.grid.refresh();
    } else if (args.item.id === 'clear-filter') {
      this.grid.clearFiltering();
      this.grid.search('');
      const userId = this.commonService.getUSER().userId
      const gridValue = ""
      this.savePersistence();
    } else if (args.item.id === 'excel-export') {
      const dataSource = getExcelDataSource(this.grid);
      let excelExportProperties: ExcelExportProperties = {
        dataSource,
        hierarchyExportMode: 'Expanded',
        theme: {
          header: { bold: true, backColor: '#eeeeee', fontSize: 15 }
        },
        fileName: `Leads (${getCurrentDate()}).xlsx`
      };
      this.grid.excelExport(excelExportProperties);
    }
  }

  savePersistence(value?: any) {
    const userId = this.commonService.getUSER().userId
    const gridValue = value ?? this.grid?.getPersistData()
    this.commonService.savePersistence({ userId, name: this.gridName, value: gridValue, appId: Applications.RimsSales }).subscribe((res: any) => {
      localStorage.setItem(`grid${this.gridName}`, value ?? this.grid?.getPersistData());
    });
  }

  @Input() fromServiceApp = false;
  @Output() openLeadsPopupEvent = new EventEmitter<any>();

  openLeadsPopup(id: string = null, tab: string = tabsModel.details) {
    if (this.fromServiceApp) {
      this.openLeadsPopupEvent.emit({ id, tab });
      return;
    }
    const dialog = this.dialog.open(LeadsPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      autoFocus: false,
      data: {
        id: id,
        isMaximized: true,
        isFromService: this.isFromService,
        isFromServiceOrder: this.isFromServiceOrder,
        tab,
        fromServiceApp: this.fromServiceApp
      }
    });
    dialog.afterClosed().subscribe(result => {
      if (result) {
      this.grid.refresh();
        this.homeService.hitRefreshPods({
          // notif_pod: true,

          LeadStats_pod: true, 
          OppStats_pod: true, 
          PropStats_pod: true, 
          SOStats_pod: true,

          // PV_pod: true,
          // COL_pod: true,

          // SOUPCA_pod: true,
          // SOWUCSAP_pod: true,
          // SORTBP_pod: true,
          // SOAA_pod: true,

          NL_pod: true,
          UL_pod: true,
        });
      }
    });
  }
onCreateOpportunityClick(data: any) {
    // latest code to accept is below;
    var assignedResourceId = data?.assignedResourceId || "";
    var assignedResourceName = data?.assignedResourceName || "";
    this.showLoader = true;
    this.commonService.onCreateOpportunityWithOpenTodosPrequisiteValidations(data?.mappedSoldToBP, data?.salesLeadId)
    .then((results) => {
      this.showLoader = false;
      switch (results.action) {
        case "openOpportunityPopup":
          if ([UserRoles.salesDistricMgr, UserRoles.salesRegionalMgr, UserRoles.salesAdmin].includes(this.commonService.getUSER()?.role) || this.commonService?.getUSER()?.canActAsSalesRep) {
            results.data.salesRepId = assignedResourceId;
            results.data.salesRepName = assignedResourceName;
          }
          this.openOpportunityPopup({...results?.data, ...data});          
          break;
        case "openLeadsPopup":
          this.openLeadsPopup(results?.data);
          break;
        case "openTodosPopup":
          this.openToDoPopup(results?.data, tabsModel.details);          
          break;      
        case "error":
          this.commonService.showNotification("error", "Unable to perform this action!");          
          break;      
        default:
          break;
        }
      })
      // latest code to accept is above;
    }
    
      openToDoPopup(data?: any, tab: tabsModel = tabsModel.details, copyTodo?: boolean) {
        const dialogRef = this.dialog.open(ToDosPopupComponent, {
          disableClose: true,
          maxWidth: '100vw',
          maxHeight: '100vh',
          width: '80%',
          height: '100%',
          enterAnimationDuration: '0',
          exitAnimationDuration: '0',
          data: {
            copyTodo,
            isMaximized: true,
            tab,
            ...data
          },
        });
    
        dialogRef.afterClosed().subscribe((result) => {
          if(result?.copyTodo) {
            this.openToDoPopup(result, tabsModel.details, true);
          }
        });
      }
  openOpportunityPopup(data) {
    const proceedOpenningOpportunityPopup = (data: any) => {
      const dialog = this.dialog.open(OpportunitiesPopupComponent, {
          backdropClass: 'no-backdrop',
          disableClose: true,
          maxWidth: '100vw',
          maxHeight: '100vh',
          width: '100%',
          height: '100%',
          enterAnimationDuration: '0',
          exitAnimationDuration: '0',
          autoFocus: false,
          data: {
            id: data.id,
            isMaximized: true,
            type: 'direct',
            fromLeads: true,
            leadData: {
              salesLeadId : data.salesLeadId,
              source: data.source,
              creatorId: data.creatorId,
              creatorName: data.creatorName,
              leadCreatedDate: data.createdDate,
              leadCallNotes: data.notes,
              reasonNotes: data.reasonNotes,
              salesRepName: data.salesRepName,
              salesRepId: data.salesRepId,
              productLine: data.productCategory
            },
            bpData: {
              name: data?.mappedBPName,
              id: data?.mappedSoldToBP,
              address: data?.mappedBPAddress,
              email: data?.mappedBPEmail,
              contact: data?.mappedBPTelephone,
              city: data?.city,
              state: data?.stateProvince,
              zipCode: data?.zipCode,
              country: data?.country,
              countryId: data?.countryId ?? 1
            }
          }
        });
        dialog.afterClosed().subscribe(result => {
          if (result) {
            this.grid.refresh();
            this.homeService.hitRefreshPods({
                // notif_pod: true,
    
                LeadStats_pod: true, 
                OppStats_pod: true, 
                PropStats_pod: true, 
                SOStats_pod: true,
    
                // PV_pod: true,
                // COL_pod: true,
    
                // SOUPCA_pod: true,
                // SOWUCSAP_pod: true,
                // SORTBP_pod: true,
                // SOAA_pod: true,
    
                NL_pod: true,
                UL_pod: true,
            });
            window.location.href = window.location.origin + '/opportunities';
          }
        });
    }
    if(data.leadIdFromLeadsModule) {
      this.leadsService.getLeadById(data.leadIdFromLeadsModule).subscribe({
        next: (res: any) => {
          proceedOpenningOpportunityPopup(res?.result);         
        }
      })
    } else {
      proceedOpenningOpportunityPopup(data);
    }
  }

  commandClick(args: any, grid) {
    switch (args.commandColumn.title) {
      case 'Details':
        this.openLeadsPopup(args.rowData.salesLeadId)
        break;
      case 'Convert to Opportunity':
        this.commonService.showConfirmation("Are you sure, you want to convert this lead to opportunity?")
        .then(result => {
          if (result.isConfirmed) {
            this.onCreateOpportunityClick(args.rowData);
            
        }})
        break;
      case 'Map Business Partner':
        this.onBPIdClick(args.rowData?.soldToExtId || args.rowData?.soldToBp);
        break;
      case 'Links':
        this.openLeadsPopup(args.rowData.salesLeadId, tabsModel.links);
        break;
      case 'Comments':
        this.sharedService.globalComments = {
          grid, module: ModuleNames.SalesLead, moduleId: args.rowData.salesLeadId, showComments: true
        }
        break;
      case 'Attachments':
        this.openLeadsPopup(args.rowData.salesLeadId, tabsModel.attachments);
        break;
      case 'History':
        this.openLeadsPopup(args.rowData.salesLeadId, tabsModel.history);
        break;
      default:
        console.log('Unknown command');
    }
  }
  onActionBegin(args: any) {
    gridActionBeginForFilteringOdataV4(args);
    if (args.requestType === 'infiniteScroll') setTimeout(() => this.grid?.hideSpinner());
}
  onGridActionComplete(args: any, grid: any) {
    if (args.requestType === 'infiniteScroll') {
      setTimeout(() => grid?.hideSpinner());
    }

    // gridActionsForFiltering(args, grid);
    updateFilterIcon(args, grid);
    if (GridPersistRequests.includes(args.requestType)) {
      this.savePersistence(this.grid?.getPersistData());
    }
    applyInfiniteGridTotalCount(grid, (count) => { this.totalRecords = count; }, args.requestType, args);
}

  dataBound(args: any) {
    setTimeout(()=> {
        updateFilterIcon({ requestType: 'filtering' }, this.grid);
    },)
    bindInfiniteScrollPrefetch(this.grid, () => this.totalRecords, 0, (count) => { this.totalRecords = count; });
}

  onRowDataBound(args: any) {
    const data = args.data;
    const $row = args.row;

    if (data.linkColorCode && !this.isFromService) {
      const element = $row.getElementsByClassName('linked-items')[0]
      if (element) {
        element.style.color = data.linkColorCode;
      }
    }
    if (args.data.attColorCode) {
       const element = $row.getElementsByClassName('attachments-items')[0];
      if (element) {
        element.style.color = args.data.attColorCode;
      }
    }
    if (data.commentColor) {
      const element = $row.getElementsByClassName('comments-items')[0]
      if (element) {
        element.style.color = data.commentColor;
      }
    }
    if (data.mappedColorCode) {
      const element = $row.getElementsByClassName('map-business-partner-item')[0]
      if (element) {
        element.style.color = data.mappedColorCode;
      }
    }
    if (data?.canMap && !this.isFromService) {
      $row?.getElementsByClassName('map-business-partner-item')[0]?.classList.remove('disabled');
    } else {
      $row?.getElementsByClassName('map-business-partner-item')[0]?.classList.add('disabled');
    }

    if (data.canConvert && !this.isFromService) {
      $row?.getElementsByClassName('convert-opportunity-item')[0]?.classList.remove('disabled');
    } else {
      $row?.getElementsByClassName('convert-opportunity-item')[0]?.classList.add('disabled');
    }

    if (this.isFromService) {
      const mapBtn = $row?.getElementsByClassName('map-business-partner-item')[0] as HTMLElement;
      if (mapBtn) mapBtn.style.display = 'none';

      const convertBtn = $row?.getElementsByClassName('convert-opportunity-item')[0] as HTMLElement;
      if (convertBtn) convertBtn.style.display = 'none';

      const linkBtn = $row?.getElementsByClassName('linked-items')[0] as HTMLElement;
      if (linkBtn) linkBtn.style.display = 'none';
    }
  }


  getStatusClass(status: string) {
    return this.commonService.getStatusClass(status);
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }
}
